import { Component } from '@angular/core'
import { Emittable, Emitter } from '@ngxs-labs/emitter'
import { PlugplayState } from '../../states/plugplay-state.service'
import { CoreService } from '../../../../services'
import { SchemaUtil } from '../../../../utils'

@Component({
  selector: 'app-step7-result',
  templateUrl: './step7-result.component.html',
  styleUrls: ['./step7-result.component.scss'],
})
export class Step7ResultComponent {
  @Emitter(PlugplayState.setActive)
  private readonly setActive: Emittable<number>
  @Emitter(PlugplayState.setHighestLastStepCompleted)
  public readonly setHighestLastStepCompleted: Emittable<number>
  private currentPageNumber = 0
  private endPageNumber = 1
  public eanErrorCount = 0
  public priceErrorCount = 0
  public supplierErrorCount = 0
  public loading = true
  constructor(private core: CoreService) {
    this.setActive.emit(6)
    this.core.services.product.getList({ page: this.currentPageNumber }, SchemaUtil.productList).then(value => {
      this.endPageNumber = value.paginator.endPage
      const promList = []
      for (let i = 0; i < this.endPageNumber; i++) {
        promList.push(
          this.core.services.product.getList({ page: i }, { ean: null, purchasePrice: null, supplier: { id: null } }),
        )
      }
      Promise.all(promList)
        .then(response => {
          response.forEach(row => {
            row.items.forEach(product => {
              if (!product.ean) {
                this.eanErrorCount += 1
              }
              if (!product.purchasePrice) {
                this.priceErrorCount += 1
              }
              if (!product.supplier?.id) {
                this.supplierErrorCount += 1
              }
            })
          })
        })
        .finally(() => (this.loading = false))
    })
  }
}
